import React, { useState } from 'react';
import {
    PlusOutlined
} from '@ant-design/icons';
import {
    Button,
    Form,
    Modal,
    Select,
    Row,
    Col,
    InputNumber,
    message,
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function AddTransferItems({ products }) {

    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/cartItem/createTransferCartItems', data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => form.resetFields()
                    });
                    queryClient.invalidateQueries(['/api/cartItem/getTransferCartItems'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({ ...values, transaction_type: 'TRANSOUT' }))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    };

    const onCancelCreate = () => {
        setOpen(false);
    }

    const onSelectProduct = (value, option) => {
        // console.log('value; ', value);
        // console.log('option; ', option);
        const selectProduct = products.find(f => f._id === value)
        form.setFieldsValue({
            price: selectProduct.average_price,
        });
    }

    return (
        <div>
            {contextHolder}
            <Row justify="end">
                <Col>
                    <Button
                        type='primary'
                        icon={<PlusOutlined />}
                        onClick={() => setOpen(true)}
                    >เพิ่มสินค้า</Button>
                </Col>
            </Row>
            <Modal
                open={open}
                title="เลือกสินค้า"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name='addProduct'
                >
                    <Form.Item
                        name="product"
                        label="รุ่น"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="children"
                            onSelect={onSelectProduct}
                        >
                            {products.map((product) => (
                                <Select.Option key={product._id} value={product._id} >
                                    {`${product.name}:${product.brand?.name} ${product.description}`}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Row gutter={[8, 8]}>
                        <Col xs={12}>
                            <Form.Item
                                label="จำนวน"
                                name="quantity"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="ราคา/หน่วย"
                                name="price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'กรุณากรอกข้อมูล!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>
    )
}
